import { useTranslation } from 'react-i18next';
import { VdsBadgePill } from '@volt/volt-extended-components-react';
import { ReactElement } from 'react';
import ElementList from '@cas/components/tables/cells/element-list/ElementList';
import { EmailNotificationSendStatus } from '@casops/store/apis/personnelSafetyApi';

interface EmailStatusCellRendererProps {
  value: EmailNotificationSendStatus;
}

const getColour = (
  value: EmailNotificationSendStatus,
): 'danger' | 'healthy' | 'information' | 'neutral' | 'warning' => {
  switch (value) {
    case EmailNotificationSendStatus.Pending:
      return 'warning';

    case EmailNotificationSendStatus.Sent:
      return 'healthy';

    case EmailNotificationSendStatus.Error:
      return 'danger';

    default:
      return 'neutral';
  }
};

export function EmailStatusCellRenderer({ value }: EmailStatusCellRendererProps): ReactElement {
  const { t } = useTranslation();

  return (
    <ElementList>
      <VdsBadgePill
        value={t(`EmailStatus.${value}`)}
        size="extra-small"
        statusColor={getColour(value)}
      />
    </ElementList>
  );
}

export default EmailStatusCellRenderer;
